import { Component, Input, OnInit, Output, forwardRef, EventEmitter, AfterViewInit, ElementRef, ViewChild, Injector } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, NgModel, Validator, AbstractControl } from '@angular/forms';
import { IndicatorDto, IndicatorServiceProxy, IndicatorFormulaDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DxTreeListModule } from 'devextreme-angular';

import * as _ from 'lodash';

interface Filter {
    data: {
        id: number;
        indicator: string;
        isActive: boolean;
        isActiveFilter: string;
        sequenceNo: number,
        parentId: string,
        gParentId: number,
        sequenceValue: string
    };
    children: Filter[];
    expanded: boolean;
}

@Component({
    selector: 'indicator-formula',
    templateUrl: './indicator-formula.component.html',
    styleUrls: ['./indicator-formula.component.css']
})

export class IndicatorFormulaComponent extends AppComponentBase implements OnInit {

    @ViewChild('formulaInput') formulaInput: ElementRef;
    @ViewChild('treeList') treeList: ElementRef;

    @Input() indicators: IndicatorDto[] = [];
    @Input() formula: IndicatorFormulaDto;
    @Input() indicatorId: number;
    @Output() onFormulaChange = new EventEmitter();

    clickTimer: any;
    lastRowCLickedId: any;
    formulaItem: IndicatorFormulaDto;
    filteredIndicators: Filter[];
    private indicatorsDuplicate: Filter[];
    isIndicatorDataLoading: boolean;

    errors: string[] = [];
    arithmeticOperators = ['+', '-', '/', '*'];
    validatedFormula = '';
    private filter: Filter = {
        data: {
            id: 0,
            indicator: 'null',
            isActive: true,
            isActiveFilter: 'true',
            sequenceNo: 0,
            parentId: 'null',
            gParentId: 0,
            sequenceValue: 'null'
        },
        children: [],
        expanded: true
    };
    constructor(
        injector: Injector,
        private _indicatorService: IndicatorServiceProxy
    ) {
        super(injector);
    }

    ngOnInit() {
        // this._indicatorService.getFormulaOfIndicatorAsync(this.indicatorId)
        //   .subscribe(result => {
        //     this.formulaItem = new IndicatorFormulaDto();
        //     this.formulaItem.id = result.id;
        //     this.formulaItem.formula = result.formula;
        //     debugger;
        //   });
        if (_.isUndefined(this.formula) || _.isNull(this.formula)) {
            this.formula = new IndicatorFormulaDto();
            this.formula.formula = '';
        }
        this.initDxTree(this.indicators);
    }

    initDxTree(indicatorList: IndicatorDto[]) {
        this.isIndicatorDataLoading = true;
        this.filteredIndicators = [];
        for (let i = 0; i < indicatorList.length; i++) {
            const item = indicatorList[i];
            const data: Filter = {
                data: {
                    id: item.id,
                    indicator: item.nameValue,
                    isActive: item.isActive,
                    isActiveFilter: item.isActive.toString(),
                    sequenceNo: item.sequenceNo,
                    parentId: item.parentId == null ? null : item.parentId.toString(),
                    gParentId: null,
                    sequenceValue: item.sequenceNo.toString()
                },
                children: [],
                expanded: true
            };

            this.showChildren(data);
            this.filteredIndicators.push(data);
        }
    }

    private showChildren(node): void {
        let parentId = node.data.id;

        this._indicatorService.getAllIndicatorsAsync(parentId, undefined)
            .finally(() => {
                this.filterList();
                this.isIndicatorDataLoading = false;
            })
            .subscribe((result) => {
                for (let i = 0; i < result.items.length; i++) {
                    const item = result.items[i];

                    const data: Filter = {
                        data: {
                            id: item.id,
                            indicator: item.nameValue,
                            isActive: item.isActive,
                            isActiveFilter: item.isActive.toString(),
                            sequenceNo: item.sequenceNo,
                            parentId: item.parentId.toString(),
                            gParentId: node.data.parentId,
                            sequenceValue: node.data.sequenceValue + '.' + item.sequenceNo.toString()
                        },
                        children: [],
                        expanded: true
                    };

                    node.children.push(data);
                    this.showChildren(data);
                }
            });
    }

    private filterList() {
        let temp = _.cloneDeep(this.filteredIndicators);

        for (let i = 0; i < temp.length; i++) {
            let indicator = temp[i];
            if (indicator.children.length !== 0) {
                for (let j = 0; j < indicator.children.length; j++) {
                    let child = indicator.children[j];
                    if (child.children.length !== 0) {
                        child.children = this.applyFilter(child.children);
                    }
                }
                indicator.children = this.applyFilter(indicator.children);
            }
        }
        this.indicatorsDuplicate = this.applyFilter(temp);
    }

    private applyFilter(filteredList: Filter[]): Filter[] {
        let viewFilter = this.filter;
        let list = filteredList.filter(function (filter: Filter) {

            if (filter.children.length > 0) {
                return true;
            }

            let parentGosterge = true;
            if (viewFilter.data.parentId !== 'null') {
                if (filter.data.id.toString() === viewFilter.data.parentId) {
                    parentGosterge = true;
                } else if (filter.data.parentId !== null && filter.data.parentId === viewFilter.data.parentId) {
                    parentGosterge = true;
                } else if (filter.data.gParentId !== null && filter.data.gParentId.toString() === viewFilter.data.parentId) {
                    parentGosterge = true;
                } else {
                    parentGosterge = false;
                }
            }
            let isActive = viewFilter.data.isActiveFilter !== 'null' ? filter.data.isActiveFilter.toString() === viewFilter.data.isActiveFilter : true;

            return isActive && parentGosterge;
        });

        return list;
    }

    clearFormula() {
        this.formula.formula = '';
        this.validatedFormula = '';
        $(this.formulaInput.nativeElement).focus();
        this.onFormulaChange.emit({ formula: this.formula, isValidFormula: false });
    }

    validateFormula() {
        this.errors = [];
        if (this.formula.formula.length === 0) {
            this.errors.push('Fomula can not be empty!');
        }
        // let words = _.words(this.formula);
        // console.log(words);
        let arValidate = this.formula.formula.includes('+') || this.formula.formula.includes('-') || this.formula.formula.includes('/') || this.formula.formula.includes('*');
        if (!arValidate) {
            this.errors.push('No arithmetic operator!');
        }
        if (this.formula.formula.startsWith('+') || this.formula.formula.startsWith('-') || this.formula.formula.startsWith('/') || this.formula.formula.startsWith('*')) {
            this.errors.push('Can not begin with arithmetic operator!');
        }
        if (this.formula.formula.endsWith('+') || this.formula.formula.endsWith('-') || this.formula.formula.endsWith('/') || this.formula.formula.endsWith('*')) {
            this.errors.push('Can not end with arithmetic operator!');
        }
        if (this.formula.formula.startsWith(')') || this.formula.formula.endsWith('(')) {
            this.errors.push('Brackets not placed correctly!');
        }

        let splits = this.formula.formula.split(/[+*\/-]/);
        //çift operatör kontrolü
        if (splits.indexOf('') > -1 || splits.indexOf(' ') > -1) {
            this.errors.push('Can not include arithmetic operators consecutively!');
        }

        //TODO cemre-> sabit sayıdan sonra operator olmaması kontrol edilmeli
        //_.each(splits, function (item, key) {
        //_.each(splits, function (item, key) {
        //    if (isNumber(parseInt(item))) {
        //        console.log(item);
        //    }
        //})

        let result = this.formula.formula.split(/[+*\/-]/);
        let varRegex = /(\[([^\]]+)(\#\d)])/;
        let varSplitter = _.trim(this.formula.formula).split(varRegex);
        console.log(varSplitter);
        this.validatedFormula = this.formula.formula.trim();
        let reg = /(\d|{([^}]*)})|([-+*\/])|[(]|[)]/;
        let regExResult = reg.test(this.formula.formula);
        if (!regExResult) {
            this.errors.push('Does not match the regex pattern!');
        }
        // More logic here about operator priority and paranthesis

        //validate kontrolünden sonra sonuc döndürülüyor.
        if (this.errors.length > 0) {
            this.onFormulaChange.emit({ formula: this.formula, isValidFormula: false });
        } else {
            this.onFormulaChange.emit({ formula: this.formula, isValidFormula: true });
        }
    }

    indicatorAndSequnceColumn(rowData) {
        return rowData.data.sequenceValue + ' ' + rowData.data.indicator;
    }

    onRowClick(event) {
        if (this.clickTimer && this.lastRowCLickedId === event.rowIndex) {
            clearTimeout(this.clickTimer);
            this.clickTimer = null;
            this.lastRowCLickedId = event.rowIndex;

            let data = event.data.data;
            let hasGParent = data.gParentId === null;
            let hasParent = data.parentId === null;
            let isParent = hasGParent || hasParent;
            if (isParent) {
                return false;
            }
            this.formula.formula += '{' + data.indicator + '{' + data.id + '}} ';
            // this.formula += ' [' + data.id + ' ]';

            $(this.formulaInput.nativeElement).focus();
            setTimeout(() => {
                $(this.formulaInput.nativeElement).focus();
                //this.onFormulaChange.emit({ formula: this.formula, isValidFormula: this.errors.length > 0 ? false : true });
            }, 0);

        } else {
            this.clickTimer = setTimeout(function () {
                console.log('single');
            }, 250);
        }

        this.lastRowCLickedId = event.rowIndex;
    }
    //bunun yerine validateFormula fonksiyonunda emit
    //modelChanged($event) {
    //    let isValidFormula = true;
    //    if (this.errors.length > 0) {
    //        isValidFormula = false;
    //    }
    //    this.onFormulaChange.emit({ formula: this.formula, isValidFormula: isValidFormula });
    //}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/indicator-formula/indicator-formula.component.ts